export const font = {
    family: {
        main: '"Inter", SF Pro Display,system-ui,helvetica,sans-serif,sans-serif',
    },
    size: {
        micro:      '0.75rem',  // -- leveled up temporary to 12px '0.5rem',   //  8 px
        small:      '0.75rem',  // -- leveled up temporary to 12px '0.625rem', // 10 px
        badge:      '0.625rem', // -- leveled up temporary to 12px '0.688rem', // 11 px
        compact:    '0.75rem',  // 12 px
        regular:    '0.875rem', // 14 px
        link:       '0.938rem', // 15 px
        header:     '1rem',     // 16 px
        smalltitle: '1.125rem', // 18 px
        title:      '1.25rem',  // 20 px
        large:      '1.5rem',   // 24 px
        largeIcon:  '1.75rem',  // 28 px
        extralarge: '1.875rem', // 30 px
        ultralarge: '2.25rem',  // 36 px
    },
    weight: {
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
    },
    spacing: {
        trackingTightest:       '-0.75px',
        trackingTightModal:     '-0.5px',
        trackingTightSection:   '-0.6px',
        trackingTightKpi:       '-0.5px',
        trackingTightTab:       '-0.275px',
        trackingTightInactive:  '-0.25px',    
        trackingNormal:         '0px',
        trackingWideField:      '0.516px',
        trackingWideMeta:       '0.5px',
        trackingWideFormField:	'0.55px',
        trackingWideBtn:	    '0.7px',
        trackingWideAccordion:	'0.811px',
        trackingWideBreadcrumb:	'1px',
    }
}

export const spacing = {
    radius: {
        item: '0.75rem',        // 12 px (overall buttons and badges)
        fields: '0.5rem',       //  8 px
        container: '1.5rem',    // 24 px
        tab: '1rem',            // 16 px
        tableHeader: '1rem',    // 16 px
        tableHeaderCell: '0.5rem',  //  8 px
        tableBody: '1rem',      // 16 px
        tableBodyCell: '0rem',  //  0 px
        modal: '1.5em',         // 24 px
        menu: '1rem',           // 16 px
        timeline: '1rem',       // 16 px
        timelineDot: '0.75rem'  // 12 px
    },
    padding:{
        card: '1.25rem',        // 20 px
        cardSmall: '0.625rem 0.625rem 0.813rem 0.625rem',
        popover: '0.625rem',    // 10 px
        content: '1.563rem',    // 25 px
        input: '0.625rem 0.75rem',     // 10 px 12 px
        main: '1.875rem',       // 30 px
        modal: '1.563rem',      // 25 px
        modalXL: '1.875rem 2.5rem', // 30 px 40 px
        tableSpace: '0.625rem', // 10 px
        tableHeader: '6px',     //  6 px
        tableRow: '1rem',       // 16 px
        timeline: '2.5rem',     // 40 px
        accordionDetail: '4px', //  4 px
        
    },
    margin:{
        small: '0.25rem',       //  4 px
        medium: '0.75rem',      // 12 px
    },
    gap:{
        small:'0.25rem',        //  4 px
        medium:'0.75rem',       // 12 px
        wide:'1rem',            // 16 px
        timeline: '0.625rem',   // 10 px
        card:'1.5rem',          // 24 px
    },
    size:{
        iconDisplay:'4.25rem',
        inputSize:'3.5rem',
        cardMinSize:'12rem',
        timelineDotSize:'3rem' // 48 px
    }
}

export const colorPalette = {
    neutral:{
        neutra_near_black:  '#0F172A',
        neutra_800:         '#1E293B',
        neutra_700:         '#454652',
        neutra_600:         '#767683',
        neutra_slate_500:   '#64748B',
        neutra_500:         '#94A3B8',
        neutra_475:         '#A0AEC1',
        neutra_400:         '#A7ADCA',
        neutra_350:         '#BDC1D7',
        neutra_300:         '#C4D0E0',
        neutra_pj_border:   '#CBD5E1',
        neutra_pj_inactive: '#E0E3E6',
        neutra_200:         '#F1F5F9',
        neutra_175:         '#F8FAFC',
        neutra_150:         '#F2F4F7',
        neutra_100:         '#FAFBFF',
        neutra_50:          '#FFFFFF',
    },
    blue:{
        blue_300:       '#70C3FF',
        blue_200:       '#64B8FF',
        blue_100:       '#E4F2FF',
        blue_ghost:     '#F7F9FF',
    },
    navyViolet: {
        navy_900:       '#1A237E',
        navy_950:       '#000666',
        violet_900:     '#312E81',
        violet_950:     '#1E1B4B',
    },
    indigo: {
        indigo_500:     '#6366f199',
        indigo_400:     '#A1A3F7',
        indigo_200:     '#C7D2FE',
        indigo_100:     '#EEF2FF',
    },
    teal: {
        teal_600:       '#0291AB',
        teal_50	:       '#E6F6F9',
    },
    green: {        
        green_600:      '#059669',
        green_400:      '#22CA90',
        green_50:       '#E4FFF3',
        green_50_success:   '#ECFDF5',
    },
    red: {
        red_40:         '#FDE0E3',
        coral_bright_400:   '#EC4D3F',
    },
    purple: {
        purple_600:	    '#6A3EDA',
        purple_200:	    '#BEB0FF',
        purple_100:	    '#F6F3FD',
        purple_card:    '#EFF3FD',
    },
    orange: {
        orange_soft:    '#FFA25A',
        orange_400:	    '#FF8B4C',
        orange_50:	    '#FFF0E8',
    },
    amber: {
        amber_soft:		'#FEDD7F',	
        amber_400:		'#F3BD40',	
        amber_50:		'#FDFAF3',	
        amber_required:	'#FDE68A',
    },
    pink: {
        pink_400:		'#FF7EB7',	
        pink_50:		'#FEF4F9',	
        coral_400:		'#E78B7C',
        coral_50:		'#FAECE9',	
        coral_bright_400:   '#EC4D3F',
    },
    tan: {
        tan_400:		'#C69D75',
        tan_50:		    '#FCF8F2',
    },
    divers: {
        red_badge:      '#FD8B89',
        red_required:   '#F32D43',
        black:          '#000000',
    },
}

// Used for basic theme coloring: background, text, borders, buttons state...
export const colors = {
    primary: {
        main1: colorPalette.navyViolet.navy_900,
        main2: colorPalette.navyViolet.navy_950,
        main3: colorPalette.indigo.indigo_200,
        light: colorPalette.teal.teal_600+'60',
        contrastText: '#fff',
    },
    secondary: {
        main1: colorPalette.neutral.neutra_50,
        main2: colorPalette.indigo.indigo_200,
        main3: colorPalette.navyViolet.navy_900,
        light: '#7e7e7e26',
        contrastText: '#fff',
    },
    error: {
        main1:colorPalette.divers.red_required,
        main2:colorPalette.divers.red_required,
        main3:colorPalette.pink.pink_50,
        light: '#7e7e7e26',
        contrastText: '#fff',
    },
    warning: {
        main: '#ed6c02',
    },
    info: {
        main: '#0288d1',
        light: '#e0f3fb',
    },
    success: {
        main1: colorPalette.green.green_400,
        main2: colorPalette.green.green_400,
        main3: colorPalette.green.green_50,
        light: '#7e7e7e26',
        contrastText: '#fff',
    },
    background: {
        default: colorPalette.indigo.indigo_100,
        paper: colorPalette.neutral.neutra_50,
        menu: colorPalette.blue.blue_ghost,
        table: '#f6f6f6',
    },
    text: {
        primary: colorPalette.navyViolet.navy_900,
        secondary: colorPalette.neutral.neutra_500,
        disabled: '#9ca3af',
        btnPrimary: '#fff',
        btnSecondary: '#fff',
        black: colorPalette.divers.black,
        popoverTitle: colorPalette.indigo.indigo_400,
        table: '#495057',
        timeline: colorPalette.neutral.neutra_700,
        timelineTime: colorPalette.neutral.neutra_600,
        detail: colorPalette.indigo.indigo_400,
    },
    borders: {
        light: colorPalette.indigo.indigo_200,
        hover: colorPalette.indigo.indigo_400,
        active: colorPalette.navyViolet.navy_900,
        black: colorPalette.divers.black,
        timeline: colorPalette.neutral.neutra_200,
    },
    divider: '#e5e7eb',
}

// Used for specific theme coloring: badge colors, specific item colors (table, card, breadcrumb)
export const themeColors = {
    primary: {
        main: colorPalette.navyViolet.navy_900,
        light: colorPalette.indigo.indigo_200,
        contrastText: '#fff',
    },
    secondary: {
        main: colorPalette.neutral.neutra_500,
        light: colorPalette.neutral.neutra_150,
    },
    error: {
        main: colorPalette.red.coral_bright_400,
        light: colorPalette.red.red_40,
    },
    warning: {
        main: colorPalette.orange.orange_400,
        light: colorPalette.orange.orange_50,
    },
    info: {
        main: colorPalette.blue.blue_200,
        light: colorPalette.blue.blue_ghost,
    },
    success: {
        main: colorPalette.green.green_400,
        light: colorPalette.green.green_50,
    },
    control: {
        main: colorPalette.tan.tan_400,
        light: colorPalette.tan.tan_50,
    },
    pink:{
        main: colorPalette.pink.pink_400,
        light: colorPalette.pink.pink_50,
    },
    purple:{
        main: colorPalette.purple.purple_600,
        light: colorPalette.purple.purple_100,
    },
    coral:{
        main: colorPalette.pink.coral_400,
        light: colorPalette.pink.coral_50,
    },
    teal:{
        main: colorPalette.teal.teal_600,
        light: colorPalette.teal.teal_50,
    },
    background: {
        default: colorPalette.indigo.indigo_100,
        paper: colorPalette.neutral.neutra_50,
    },
    text: {
        primary: '#202020',
        secondary: '#fff',
        disabled: '#9ca3af',
    },
    card: {
        backgroundSmall: colorPalette.purple.purple_card,
    },
    popover: {
        background: colorPalette.indigo.indigo_100,
    },
    table: {
        base: colors.background.paper,
        hover: colorPalette.indigo.indigo_200,
        active: colorPalette.indigo.indigo_400,
        headerText: colorPalette.neutral.neutra_500,
        bodyText: colors.text.primary,
    },
    breadcrumb: {
        base: colorPalette.neutral.neutra_475,
        hover: colorPalette.navyViolet.navy_900,
    },
    icon: {
        background: `${colors.primary.main1}0D`,
        color: colorPalette.indigo.indigo_400,
        titleColor: colorPalette.indigo.indigo_200,
    },
    divider: {
        base: colorPalette.neutral.neutra_150,
        card: colorPalette.neutral.neutra_175,
        tableCell: 'transparent'
    }
};

// Different custom shadows used
export const shadows = {
    tableRow: `0px 1px 2px 0px ${colors.borders.light}`,
    tableRowGray: `0px 1px 2px 0px ${colors.borders.black}0D`,
    tabShadows: `0 1px 2px 0 ${colors.borders.hover}`,
    cardShadows: `1px 2px 3px ${colors.borders.hover}80`,
    globalFocusOutline: `0.2rem solid ${colors.primary.light}`,
    globalFocusShadow: `0 0 0 0.2rem ${themeColors.primary.light}`,
    timelineShadow: `4px 4px 10px 0 ${colors.borders.black}05`,
    timelineDotShadows: `0px 4px 6px -1px ${colors.borders.black}1A`
}

// Different custom borders used
export const borders = {
    timelineBorder: `1px solid ${colors.borders.timeline}`
}

// Specific theme values that may need calculation
export const objects = {
    breadcrumbSeparator: '>',
    breadcrumbUnderline: {
        color: themeColors.breadcrumb.base,
        borderBottom: '2px solid transparent',
        '&:hover': {
            color: themeColors.breadcrumb.hover,
            borderBottomColor: themeColors.breadcrumb.hover,
        },
    },
    BigNumberColors: (receivedColor, actionArea) => {
        const color = receivedColor || 'info';  //default color schme -> info
        //if receives wrong color name, turns red/orange
        if(actionArea) {
            return({
                backgroundColor:themeColors[color]?.light ?? colorPalette.orange.orange_soft,
                color:themeColors[color]?.main ?? colorPalette.divers.red_required,
                transition: 'all 0.2s',
                '&:active':{
                    backgroundColor:themeColors[color]?.main ?? colorPalette.divers.red_required,
                    color:themeColors[color]?.light ?? colorPalette.orange.orange_soft,
                }
            })
        } else {
            return({
                backgroundColor:themeColors[color]?.light ?? colorPalette.orange.orange_soft,
                color:themeColors[color]?.main ?? colorPalette.divers.red_required,
            })
        }
    },
    iconColor: (receivedColor) => {
        const color = receivedColor || 'info';  //default color schme -> info
        //if receives wrong color name, returns to default
        return({
            color:themeColors[color]?.main ?? themeColors.info.main,
        })
    }
}

// Css classes, not supposed to be here but in a specific css sheet
export const css = {
    cardContainer: {
        minWidth: '275px',
        maxWidth: '100%',
    },
    cardContainerSmall: {
        minWidth: '275px',
        maxWidth: '100%',
        backgroundColor: themeColors.card.backgroundSmall,
    }
}